var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSidebarSecondary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "24px",
    viewBox: "0 0 29 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 3 Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "**SECONDARY-CARDHOLDER**",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dashboard-expand-1",
    transform: "translate(-22, -215)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(22, 213)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy",
    transform: "translate(0, 2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27,8 L11,8 C9.89,8 9.01,8.89 9.01,10 L9,22 C9,23.11 9.89,24 11,24 L27,24 C28.11,24 29,23.11 29,22 L29,10 C29,8.89 28.11,8 27,8 Z M27,22 L11,22 L11,16 L27,16 L27,22 Z M27,12 L11,12 L11,10 L27,10 L27,12 Z",
    id: "Shape-Copy",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0.200000003
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,4 L4,4 C2.89,4 2.01,4.89 2.01,6 L2,18 C2,19.11 2.89,20 4,20 L20,20 C21.11,20 22,19.11 22,18 L22,6 C22,4.89 21.11,4 20,4 Z M20,18 L4,18 L4,12 L20,12 L20,18 Z M20,8 L4,8 L4,6 L20,6 L20,8 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSidebarSecondary);
export default __webpack_public_path__ + "static/media/ic_sidebar_secondary.7db8082a37ba9179370932b82809b59f.svg";
export { ForwardRef as ReactComponent };